module.exports = __webpack_public_path__ + "img/smoke3.2f4493b6.png";